import "./AIMessage.css";
import { AgentChatResponseToolbar } from "./AgentChatResponseToolbar";
import { useMessageThreadInfo } from "../../hooks/useMessageThreadInfo";
import { AIResponseMessage } from "winslow-core";
import { useSelector, useDispatch } from "react-redux";
import { useRef } from "react";

import { selectLinkRecords } from "../../redux/features/appData/appDataSlice";
import { openEmployeeProfileSidebar } from "../../redux/features/agent/agentSlice";
import { ThreadInfo } from "./ThreadInfo";
import { getStoreLinkRecord } from "winslow-core";
import { LinkRecordActivity } from "../shares/LinkRecordActivity";
import { DeterminedPersonas } from "./DeterminedPersonas";
import { MessageThreadType } from "winslow-core";
import { parseMarkdown } from "../../utils/markdown";

type AIMessageProps = {
  message: AIResponseMessage;
  onExpand: (message: AIResponseMessage) => void;
  onEditInDocument?: (message: AIResponseMessage) => void;
};

export const AIMessage = ({
  message,
  onExpand,
  onEditInDocument,
}: AIMessageProps) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  const contextInfo = useMessageThreadInfo(message.thread);
  const content = message.message.kwargs.content;
  const linkRecords = useSelector(selectLinkRecords);

  const handleExpand = () => {
    onExpand(message);
  };

  const handlePreviewClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onExpand(message);
  };

  const handleThreadInfoClick = (employeeId?: string) => {
    if (employeeId) {
      dispatch(openEmployeeProfileSidebar({ employeeId }));
    }
  };

  // const getContentClass = () => {
  //   if (!needsExpansion) return "";
  //   return isExpanded ? "expanded" : "collapsed";
  // };

  return (
    <>
      <div className="agent-chat-history-prompt-response">
        {message.personaIds && (
          <DeterminedPersonas personaIds={message.personaIds} />
        )}
        <div
          className={`agent-chat-history-prompt-response-object `}
          onClick={handleExpand}>
          <div className="agent-chat-history-general">
            <div
              className="agent-chat-q-and-a-preview"
              onClick={handlePreviewClick}>
              {message.sources && message.sources.length > 0 && (
                <div className="agent-chat-q-and-a-preview-sources">
                  {/* limit to top 5 sources */}
                  {message.sources.slice(0, 5).map((linkRecordId) => {
                    const linkRecord = getStoreLinkRecord(
                      linkRecordId,
                      linkRecords ?? []
                    );
                    if (!linkRecord) return null;

                    return (
                      <LinkRecordActivity
                        key={linkRecordId}
                        linkRecord={linkRecord}
                        minimum={true}
                        showDrag={false}
                        clickIsOpen={true}
                      />
                    );
                  })}
                </div>
              )}
              <div
                ref={contentRef}
                className="agent-chat-q-and-a-preview-content markdown-body"
                dangerouslySetInnerHTML={{
                  __html: parseMarkdown(content),
                }}
              />
            </div>
          </div>
        </div>

        <div className="agent-chat-history-item-toolbar">
          <AgentChatResponseToolbar
            key={`toolbar-${message.id}`}
            message={message}
            onEditInDocument={onEditInDocument}
          />
          {contextInfo && (
            //the persona that is selected for the thread
            <ThreadInfo
              showAvatar={true}
              avatar={contextInfo.avatar}
              label={contextInfo.label}
              onClick={handleThreadInfoClick}
              employeeId={contextInfo.employeeId}
              clickable={
                contextInfo.threadType === MessageThreadType.EMPLOYEE &&
                !!contextInfo.employeeId
              }
            />
          )}
        </div>
      </div>
    </>
  );
};
